import "./style.css";
import logo from "../../../shared/lib/img/Logo_BeUpOptima4.png";

export const Header = ({ children }) => {
  return (
    <header className="app_header">
      <img src={logo} style={{ height: "40px" }} />
      {children}
    </header>
  );
};
